import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import { fetchMonthlyUsage } from './api';
import {
  FETCH_MONTHLY_USAGE,
  INITIALIZED,
  INITIALIZE_WITH_PLANS,
  REMOVE_CROSS_BROWSER_CONFIG,
  SET_WEB_AND_MOBILE_TESTING_TAB,
  UPDATE_PRODUCT_CONFIG,
} from './types';

export const initialized = createAction(INITIALIZED);
export const initializeWithPlans = createAction(INITIALIZE_WITH_PLANS);
export const setWebAndMobileTestingTab = createAction(SET_WEB_AND_MOBILE_TESTING_TAB);
export const updateProductConfig = createAction(UPDATE_PRODUCT_CONFIG);
export const removeCrossBrowserConfig = createAction(REMOVE_CROSS_BROWSER_CONFIG);

export const getMonthlyUsage = createApiAction(
  FETCH_MONTHLY_USAGE,
  ({ endDate, periods }) => fetchMonthlyUsage(endDate, periods),
  { meta: { skipErrorPage: true } },
);
